import {
  VStack,
  Heading,
  useColorModeValue,
  Container,
} from "@chakra-ui/react";
import React, { useContext, useState } from "react";
import { RoughNotation } from "react-rough-notation";
import { AppContext } from "../../context/AppContext";
import { Navigate } from "react-router-dom";
import GetOtpCard from "../../components/GetOtpCard";
import { Helmet } from "react-helmet";

const GetOtp = () => {
  const { isDark, Token, selectService } = useContext(AppContext);
  const [requestInProgress, setRequestInProgress] = useState(false);
  const [cancelBtnRequestInProgress, setCancelBtnRequestInProgress] = useState(false);

  const bg = useColorModeValue("white", "gray.800");
  const headingColor = useColorModeValue("gray.800", "white");

  if (selectService.code == undefined || selectService.code == "") {
    return <Navigate to={`/${selectService.server}`} />;
  };

  return (
    <>
      <Helmet>
        <title>Get OTP | Techy India</title>
      </Helmet>
      <VStack
        w="100%"
        bg={bg}
        minH="85vh"
        p={4}
        spacing={6}
        align="center"
      >
        <Container maxW="md" p={0}>
          <VStack spacing={6} w="100%" align="stretch">
            <Heading size="lg" textAlign="center" color={headingColor}>
              Generate Otp for{" "}
              <RoughNotation
                strokeWidth={2}
                color={"#319795"}
                type="underline"
                show={true}
              >
                {selectService.service}
              </RoughNotation>
            </Heading>
            
            <VStack w="100%" spacing={4} id="otpContainer">
              {[...Array(5)].map((_, index) => (
                <GetOtpCard 
                  key={index}
                  requestInProgress={requestInProgress} 
                  cancelBtnRequestInProgress={cancelBtnRequestInProgress} 
                  setCancelBtnRequestInProgress={setCancelBtnRequestInProgress} 
                  setRequestInProgress={setRequestInProgress} 
                  Token={Token} 
                  server={selectService.server} 
                  selectService={selectService} 
                />
              ))}
            </VStack>
          </VStack>
        </Container>
      </VStack>
    </>
  );
};

export default GetOtp;
